import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { RootState } from "../../../libraries/state_reducers/store";

import { useSelector } from "react-redux";
import Div from "../../../widget/common/ui/Div";

import { SpacingHeight } from "../../../widget/common/ui/Spacing";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import {
  HomeGuestUserBranchInfo,
  HomeGuestUserBranchLogo,
  HomeGuestUserMenu,
  HomeGuestUserSocial,
} from "./widget/HomeGuestUserBody";
import {
  applyGuestBranchSwitch,
  setGuestBranchInfo,
} from "../../../libraries/state_reducers/home_guest_user/HomeGuestUserReducer";
import { HomeGuestUserContextImport } from "../../../provider/home_guest_user/guest_home/HomeGuestUserContextProvider";

const HomeGuestUserContent = (props: { type: number }) => {
  const type: number = props.type;

  const dispatch = useDispatch();
  const switchBranchDetailSelector = useSelector(
    (state: RootState) => state.homeGuestUser.switchBranchDetail
  );

  const { branchDetail, contactList, socialLinks, homeMenu, getBranchDetail } =
    HomeGuestUserContextImport();

  useEffect(() => {
    getBranchDetail();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (switchBranchDetailSelector !== undefined) {
      getBranchDetail(switchBranchDetailSelector?.branch_id);
      dispatch(applyGuestBranchSwitch({ switchBranchDetail: undefined }));
    }
    // eslint-disable-next-line
  }, [switchBranchDetailSelector]);

  useEffect(() => {
    if (branchDetail != null) {
      dispatch(
        setGuestBranchInfo({
          branchDetail: branchDetail ?? null,
          socialLinks: socialLinks,
          contactList: contactList,
        })
      );
    }
    // eslint-disable-next-line
  }, [branchDetail]);

  return (
    <>
      {branchDetail != null ? (
        <Div>
          <HomeGuestUserBranchLogo type={type} branchDetail={branchDetail} />

          <SpacingHeight value={type === 1 ? 14 : 18} />

          <HomeGuestUserBranchInfo
            type={type}
            branchDetail={branchDetail}
            contactList={contactList}
          />

          <SpacingHeight value={type === 1 ? 60 : type === 2 ? 75 : 90} />

          <HomeGuestUserSocial type={type} socialLinks={socialLinks} />

          <SpacingHeight value={type === 1 ? 25 : type === 2 ? 50 : 65} />

          <HomeGuestUserMenu
            type={type}
            branchDetail={branchDetail}
            contactList={contactList}
            homeMenu={homeMenu}
          />

          <SpacingHeight value={type === 3 ? 20 : 0} />
        </Div>
      ) : (
        <Center className="h-100 w-100">{Loader.normal()}</Center>
      )}
    </>
  );
};

export default HomeGuestUserContent;
